import { validateMonitoringListSearch } from "@entities/monitoring/monitoring";
import { Monitoring } from "@pages/monitoring/monitoring";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/monitoring/")({
	component: RouteComponent,
	validateSearch: validateMonitoringListSearch,
});

function RouteComponent() {
	return <Monitoring />;
}
